import get from 'lodash/get';

export const getDeviceType = (context) => {
    let deviceType = '';
    if (get(context, 'deviceType.isMobile')) {
        deviceType = 'mobile';
    } else if (get(context, 'deviceType.isDesktop')) {
        deviceType = 'desktop';
    } else {
        deviceType = 'tablet';
    }

    return deviceType;
};

// expected param : service error shaped object
export const serviceErrorToAnalyticsFormat = (error) => [
    {
        errorDescription: get(error, 'errorMessage', ''),
        errorID: get(error, 'errorCode', ''),
    },
];

export const getVersion = (pageName) =>
    `apollo 1 ${new Date().getFullYear()} ${pageName}`.toLowerCase();
